import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mafc/trolly';
import TYPOGRAPHY from 'theme/typography';
import { ReactComponent as CardOnDeliveryIcon } from 'assets/svgs/icon-card-on-delivery-cart-checkout.svg';
import { CardOnDeliveryContainer, Container } from './cardOnDeliveryItem.styles';

const CardOnDeliveryItem: React.FC<{}> = () => {
  const { t } = useTranslation();

  return (
    <CardOnDeliveryContainer data-testid="__checkout_payments_card_on_delivery__">
      <CardOnDeliveryIcon width={32} height={32} />
      <Box ml="12px">
        <Container fontWeight={TYPOGRAPHY.WEIGHT[700]} color="inherit">
          {t('cardOnDeliveryText')}
        </Container>
        <Container fontWeight={TYPOGRAPHY.WEIGHT[400]} color="inherit">
          {t('cardOnDeliverySubText')}
        </Container>
      </Box>
    </CardOnDeliveryContainer>
  );
};

export default CardOnDeliveryItem;
